import type { VoidFunctionComponent } from 'react';

import Text from '../../generic/Text';
import type { QualityRule } from '../../../types';

import ComponentFilterTable from './ComponentFilterTable';

type ListRulesComponentProps = {
  title: string;
  description: string;
  onAddRule: () => void;
  rulesList: Array<Partial<QualityRule>>;
  onRemoveFilterRule: (listIndex: number) => void;
};

const ListRulesComponent: VoidFunctionComponent<ListRulesComponentProps> = (props) => (
  <div className="margin-top">
    <div className="card">
      <div className="row">
        <div className="col-md-6">
          <Text.H3>{props.title}</Text.H3>
          <p>
            {props.description}
          </p>
        </div>
        <div className="col-md-6">
          <div className="padded padded-small">
            <ComponentFilterTable
              onAddRule={props.onAddRule}
              rules={props.rulesList}
              removeRule={props.onRemoveFilterRule}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ListRulesComponent;
